/**
 * Laravel API error parsing — handles JSON validation and auth error bodies.
 */

export class ApiError extends Error {
  constructor({ status, message, errors = {}, retryAfterMinutes, silent = false }) {
    super(message || 'Request failed');
    this.name = 'ApiError';
    this.status = status;
    this.errors = errors;
    this.retryAfterMinutes = retryAfterMinutes;
    this.silent = silent;
  }
}

/**
 * @param {Response} response
 * @returns {Promise<{ status: number, message: string, errors: object, retryAfterMinutes?: number }>}
 */
export async function parseLaravelError(response) {
  const data = await response.json().catch(() => ({}));

  return {
    status: response.status,
    message: data.message || response.statusText || 'Request failed',
    errors: data.errors || {},
    retryAfterMinutes: data.retry_after_minutes,
  };
}

export function formatApiError(error, fallback = 'Request failed') {
  if (error instanceof ApiError) {
    const fieldErrors = Object.values(error.errors || {}).flat();
    if (fieldErrors.length > 0) {
      return fieldErrors[0];
    }
    return error.message || fallback;
  }
  return error?.message || fallback;
}
